// extracted by mini-css-extract-plugin
export default {"ErrorContainer":"ErrorContainer_ErrorContainer__NMioQ"};